import { ArrowUpRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/Domain/components/Shared/Button/Button';

interface ReadDocumentationButtonProps {
  href: string;
}

/** Standardized "Read documentation" link button used in every integration sheet. */
export const ReadDocumentationButton = ({ href }: ReadDocumentationButtonProps) => {
  const { t } = useTranslation('integrations');

  return (
    <Button variant="secondary" size="sm" asChild>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="read-documentation-button"
      >
        {t('integrations:read_documentation')}
        <ArrowUpRight className="size-4" />
      </a>
    </Button>
  );
};

export default ReadDocumentationButton;
